export default __webpack_public_path__ + "static/media/IMG_5376.9cd56a3f.PNG";